import { render, staticRenderFns } from "./LocationButton.vue?vue&type=template&id=b5a1c5e4&"
import script from "./LocationButton.vue?vue&type=script&lang=js&"
export * from "./LocationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports